(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["home-cta"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.home-cta').forEach(function (cta) {
    var id = cta.dataset.blockId;
    if (!id) return;

    var arrowBtn = cta.querySelector('.home-cta__arrow-btn');
    var popup = cta.querySelector('#home-cta-popup-' + id);

    if (!arrowBtn || !popup) return;

    function positionPopup() {
      popup.style.left = '';
      popup.style.right = '';
      popup.style.maxWidth = '';
      var rect = popup.getBoundingClientRect();
      var parentRect = popup.parentElement.getBoundingClientRect();
      var margin = 8;

      if (rect.right > window.innerWidth - margin) {
        popup.style.left = 'auto';
        popup.style.right = '0';
        var newLeft = parentRect.right - rect.width;
        if (newLeft < margin) {
          popup.style.left = (margin - parentRect.left) + 'px';
          popup.style.right = 'auto';
          if (rect.width > window.innerWidth - 2 * margin) {
            popup.style.maxWidth = (window.innerWidth - 2 * margin) + 'px';
          }
        }
      } else if (rect.left < margin) {
        popup.style.left = '0';
        popup.style.right = 'auto';
        var newRight = parentRect.left + rect.width;
        if (newRight > window.innerWidth - margin) {
          popup.style.left = 'auto';
          popup.style.right = '0';
          var newerLeft = parentRect.right - rect.width;
          if (newerLeft < margin) {
            popup.style.left = (margin - parentRect.left) + 'px';
            popup.style.right = 'auto';
            if (rect.width > window.innerWidth - 2 * margin) {
              popup.style.maxWidth = (window.innerWidth - 2 * margin) + 'px';
            }
          }
        }
      }
    }

    function openPopup() {
      popup.hidden = false;
      positionPopup();
      arrowBtn.setAttribute('aria-expanded', 'true');
    }

    function closePopup() {
      popup.hidden = true;
      arrowBtn.setAttribute('aria-expanded', 'false');
    }

    arrowBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      popup.hidden ? openPopup() : closePopup();
    });

    document.addEventListener('click', function (e) {
      if (!popup.hidden && !popup.contains(e.target)) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        closePopup();
        arrowBtn.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
